"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { SelectWrapper } from "@/src/components/tasks/input-wrapper";
export interface ProviderSchedule {
  provider: string;
  initials: string;
  npi: string;
  schedule: {
    mon: {
      am: string;
      pm: string;
    };
    tues: {
      am: string;
      pm: string;
    };
    wed: {
      am: string;
      pm: string;
    };
    thur: {
      am: string;
      pm: string;
    };
    fri: {
      am: string;
      pm: string;
    };
  };
}
interface ProviderScheduleTableProps {
  schedules: ProviderSchedule[];
  receivingLocationName: string;
  receivingProviderName: string;
  receivingProviderOptions: string[];
  receivingLocationOptions: string[];
  nameToScheduleNameMap: Map<string, string>;
}
function LocationCell(t0) {
  const $ = _c(10);
  const {
    location,
    selectedLocation,
    nameToScheduleNameMap
  } = t0;
  if (!location) {
    return "";
  }
  let t1;
  if ($[0] !== nameToScheduleNameMap || $[1] !== selectedLocation) {
    t1 = nameToScheduleNameMap.get(selectedLocation);
    $[0] = nameToScheduleNameMap;
    $[1] = selectedLocation;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const shortSelectedLocation = t1;
  let t2;
  if ($[3] !== location || $[4] !== shortSelectedLocation) {
    let t3;
    if ($[6] !== shortSelectedLocation) {
      t3 = (loc, idx, arr) => <span key={idx}><span className={shortSelectedLocation && loc.trim() === shortSelectedLocation ? "font-bold" : ""}>{loc.trim()}</span>{idx < arr.length - 1 && " / "}</span>;
      $[6] = shortSelectedLocation;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = location.split(" / ").map(t3);
    $[3] = location;
    $[4] = shortSelectedLocation;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <>{t2}</>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
export function ProviderScheduleTable(t0) {
  const $ = _c(50);
  const {
    schedules,
    receivingLocationName,
    receivingProviderName,
    receivingProviderOptions,
    receivingLocationOptions,
    nameToScheduleNameMap
  } = t0;
  const [selectedProvider, setSelectedProvider] = useState(receivingProviderName);
  const [selectedLocation, setSelectedLocation] = useState(receivingLocationName);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      value: "ANY",
      label: "All Providers"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== receivingProviderOptions) {
    t2 = [t1, ...receivingProviderOptions.map(_temp)];
    $[1] = receivingProviderOptions;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const providerOptions = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      value: "ANY",
      label: "All Locations"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== receivingLocationOptions) {
    t4 = [t3, ...receivingLocationOptions.map(_temp2)];
    $[4] = receivingLocationOptions;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const locationOptions = t4;
  let t10;
  let t11;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] !== locationOptions || $[7] !== nameToScheduleNameMap || $[8] !== providerOptions || $[9] !== schedules || $[10] !== selectedLocation || $[11] !== selectedProvider) {
    let t12;
    if ($[19] !== selectedProvider) {
      t12 = schedule => selectedProvider === "ANY" || schedule.provider === selectedProvider;
      $[19] = selectedProvider;
      $[20] = t12;
    } else {
      t12 = $[20];
    }
    const filteredSchedules = schedules.filter(t12);
    t10 = "space-y-6";
    let t13;
    if ($[21] !== providerOptions || $[22] !== selectedProvider) {
      t13 = <SelectWrapper value={selectedProvider} onChange={setSelectedProvider} label="Receiving Provider" placeholder="Select provider" options={providerOptions} />;
      $[21] = providerOptions;
      $[22] = selectedProvider;
      $[23] = t13;
    } else {
      t13 = $[23];
    }
    let t14;
    if ($[24] !== locationOptions || $[25] !== selectedLocation) {
      t14 = <SelectWrapper value={selectedLocation} onChange={setSelectedLocation} label="Receiving Location" placeholder="Select location" options={locationOptions} />;
      $[24] = locationOptions;
      $[25] = selectedLocation;
      $[26] = t14;
    } else {
      t14 = $[26];
    }
    if ($[27] !== t13 || $[28] !== t14) {
      t11 = <div className="space-y-2">{t13}{t14}</div>;
      $[27] = t13;
      $[28] = t14;
      $[29] = t11;
    } else {
      t11 = $[29];
    }
    t9 = "overflow-x-auto";
    t6 = "w-full border-collapse border border-gray-300 text-sm table-fixed";
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <colgroup><col className="w-28" /><col className="w-14" /><col className="w-18" /><col className="w-18" /><col className="w-18" /><col className="w-18" /><col className="w-18" /><col className="w-18" /><col className="w-18" /><col className="w-18" /><col className="w-18" /><col className="w-18" /></colgroup>;
      $[30] = t7;
    } else {
      t7 = $[30];
    }
    let t15;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <tr className="bg-muted"><th className="border border-gray-300 px-2 py-1 text-left font-medium text-foreground" rowSpan={2}>Provider</th><th className="border border-gray-300 px-2 py-1 text-left font-medium text-foreground" rowSpan={2}>Initials</th><th className="border border-gray-300 px-2 py-1 text-center font-medium text-foreground" colSpan={2}>Mon</th><th className="border border-gray-300 px-2 py-1 text-center font-medium text-foreground" colSpan={2}>Tues</th><th className="border border-gray-300 px-2 py-1 text-center font-medium text-foreground" colSpan={2}>Wed</th><th className="border border-gray-300 px-2 py-1 text-center font-medium text-foreground" colSpan={2}>Thur</th><th className="border border-gray-300 px-2 py-1 text-center font-medium text-foreground" colSpan={2}>Friday</th></tr>;
      $[31] = t15;
    } else {
      t15 = $[31];
    }
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <thead>{t15}<tr className="bg-muted/50"><th className="border border-gray-300 px-1 py-1 text-center font-medium text-xs text-foreground">AM</th><th className="border border-gray-300 px-1 py-1 text-center font-medium text-xs text-foreground">PM</th><th className="border border-gray-300 px-1 py-1 text-center font-medium text-xs text-foreground">AM</th><th className="border border-gray-300 px-1 py-1 text-center font-medium text-xs text-foreground">PM</th><th className="border border-gray-300 px-1 py-1 text-center font-medium text-xs text-foreground">AM</th><th className="border border-gray-300 px-1 py-1 text-center font-medium text-xs text-foreground">PM</th><th className="border border-gray-300 px-1 py-1 text-center font-medium text-xs text-foreground">AM</th><th className="border border-gray-300 px-1 py-1 text-center font-medium text-xs text-foreground">PM</th><th className="border border-gray-300 px-1 py-1 text-center font-medium text-xs text-foreground">AM</th><th className="border border-gray-300 px-1 py-1 text-center font-medium text-xs text-foreground">PM</th></tr></thead>;
      $[32] = t8;
    } else {
      t8 = $[32];
    }
    let t16;
    if ($[33] !== nameToScheduleNameMap || $[34] !== selectedLocation) {
      t16 = (provider_0, index) => <tr key={provider_0.provider} className={index % 2 === 0 ? "bg-background" : "bg-muted/40"}><td className="border border-gray-300 px-2 py-1 font-medium bg-primary/10 text-foreground">{provider_0.provider}</td><td className="border border-gray-300 px-2 py-1 bg-primary/10 text-foreground">{provider_0.initials}</td><td className="border border-gray-300 px-1 py-1 text-center text-xs break-words text-foreground"><LocationCell location={provider_0.schedule.mon.am} selectedLocation={selectedLocation} nameToScheduleNameMap={nameToScheduleNameMap} /></td><td className="border border-gray-300 px-1 py-1 text-center text-xs break-words text-foreground"><LocationCell location={provider_0.schedule.mon.pm} selectedLocation={selectedLocation} nameToScheduleNameMap={nameToScheduleNameMap} /></td><td className="border border-gray-300 px-1 py-1 text-center text-xs break-words text-foreground"><LocationCell location={provider_0.schedule.tues.am} selectedLocation={selectedLocation} nameToScheduleNameMap={nameToScheduleNameMap} /></td><td className="border border-gray-300 px-1 py-1 text-center text-xs break-words text-foreground"><LocationCell location={provider_0.schedule.tues.pm} selectedLocation={selectedLocation} nameToScheduleNameMap={nameToScheduleNameMap} /></td><td className="border border-gray-300 px-1 py-1 text-center text-xs break-words text-foreground"><LocationCell location={provider_0.schedule.wed.am} selectedLocation={selectedLocation} nameToScheduleNameMap={nameToScheduleNameMap} /></td><td className="border border-gray-300 px-1 py-1 text-center text-xs break-words text-foreground"><LocationCell location={provider_0.schedule.wed.pm} selectedLocation={selectedLocation} nameToScheduleNameMap={nameToScheduleNameMap} /></td><td className="border border-gray-300 px-1 py-1 text-center text-xs break-words text-foreground"><LocationCell location={provider_0.schedule.thur.am} selectedLocation={selectedLocation} nameToScheduleNameMap={nameToScheduleNameMap} /></td><td className="border border-gray-300 px-1 py-1 text-center text-xs break-words text-foreground"><LocationCell location={provider_0.schedule.thur.pm} selectedLocation={selectedLocation} nameToScheduleNameMap={nameToScheduleNameMap} /></td><td className="border border-gray-300 px-1 py-1 text-center text-xs break-words text-foreground"><LocationCell location={provider_0.schedule.fri.am} selectedLocation={selectedLocation} nameToScheduleNameMap={nameToScheduleNameMap} /></td><td className="border border-gray-300 px-1 py-1 text-center text-xs break-words text-foreground"><LocationCell location={provider_0.schedule.fri.pm} selectedLocation={selectedLocation} nameToScheduleNameMap={nameToScheduleNameMap} /></td></tr>;
      $[33] = nameToScheduleNameMap;
      $[34] = selectedLocation;
      $[35] = t16;
    } else {
      t16 = $[35];
    }
    t5 = filteredSchedules.map(t16);
    $[6] = locationOptions;
    $[7] = nameToScheduleNameMap;
    $[8] = providerOptions;
    $[9] = schedules;
    $[10] = selectedLocation;
    $[11] = selectedProvider;
    $[12] = t10;
    $[13] = t11;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t10 = $[12];
    t11 = $[13];
    t5 = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
    t9 = $[18];
  }
  let t12;
  if ($[36] !== t5) {
    t12 = <tbody>{t5}</tbody>;
    $[36] = t5;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== t12 || $[39] !== t6 || $[40] !== t7 || $[41] !== t8) {
    t13 = <table className={t6}>{t7}{t8}{t12}</table>;
    $[38] = t12;
    $[39] = t6;
    $[40] = t7;
    $[41] = t8;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  let t14;
  if ($[43] !== t13 || $[44] !== t9) {
    t14 = <div className={t9}>{t13}</div>;
    $[43] = t13;
    $[44] = t9;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  let t15;
  if ($[46] !== t10 || $[47] !== t11 || $[48] !== t14) {
    t15 = <div className={t10}>{t11}{t14}</div>;
    $[46] = t10;
    $[47] = t11;
    $[48] = t14;
    $[49] = t15;
  } else {
    t15 = $[49];
  }
  return t15;
}
function _temp2(location) {
  return {
    value: location,
    label: location
  };
}
function _temp(provider) {
  return {
    value: provider,
    label: provider
  };
}